import '../stylesheets/Overlay2D.less';
import fontawesome from '@fortawesome/fontawesome'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { Icon, Button, Container, Segment, SegmentInline } from 'semantic-ui-react'
import MainMenu from './MainMenu.js'
import AboutRxMill from './AboutRxMill.js'
import PropTypes from 'prop-types'
import HotspotContainer from './HotspotContainer';
import ContentContainer from './ContentContainer.js';
import React, { useState, useEffect } from 'react'

const OverlayUI = ({ hotspots, isMobile, isSceneLoaded }) => {
    const [aboutMillOpen, setAboutMillOpen] = useState(false)
    const [expertTalksIsOpen, setExpertTalksIsOpen] = useState(false)
    const [activeMenuItem, setActiveMenuItem] = useState("lobby")

    const openPopup = () => {
        const canvas = document.getElementsByClassName("a-canvas");
        if (canvas != null) {
            canvas[0].addEventListener('click', closePopup, true);
        }
        setExpertTalksIsOpen(true);
    }
    
    const closePopup = (event) => {
        event.preventDefault();
        setExpertTalksIsOpen(false);
        const canvas = document.getElementsByClassName("a-canvas");
        if (canvas != null) {
            canvas[0].removeEventListener('click', closePopup, true);
        }
    }
    
    // Hack to open hidden hotspot from menu bar
    useEffect(() => {
        if (window.hackOpenHiddenHotspot !== undefined && window.hackOpenHiddenHotspot !== null) return;
        window.hackOpenHiddenHotspot = openPopup;
    }, []);

    const setMainMenuActiveItem = (toActivate) => {
        setActiveMenuItem(toActivate)
    }

    const setAboutRxMillState = (toggleOpen) => {
        setAboutMillOpen(toggleOpen)
    }

    const handleBookDemoClick = () => window.open("https://rauterx.hubilo.com/community/#/exhibitor");

    return (
        <>
            <Container id="debug-container">
                {
                    (window.debug) ? <div style={{ bottom: 0, left: 0 }}>Debug</div> : <></>
                }
            </Container>
            <HotspotContainer hotspots={hotspots} isMobile={isMobile} isSceneLoaded={isSceneLoaded} setMainMenuActiveItem={setMainMenuActiveItem}/>
            <Container className="overlay-ui main-menu-container">
                <MainMenu hotspots={hotspots} isMobile={isMobile} toggleAboutMill={setAboutRxMillState} activeMenuItem={activeMenuItem} aboutMillBtnActive={aboutMillOpen}/>
            </Container>
            {
                (aboutMillOpen) ?
                <AboutRxMill setAboutRxMillState={setAboutRxMillState}/>
                : <></>
            }
            {
                (expertTalksIsOpen) ?
                <Container id="overlay-content-ui" key="overlay-content-ui" className="overlay-content scrolling-container catch-pointer-events">
                    <Icon.Group className="close-spot-content catch-pointer-events" onClick={closePopup}>
                        <Icon name="circle" size="large"/>
                        <Icon name="times circle" color="blue" size="big" onClick={closePopup}/>
                    </Icon.Group>
                    <ContentContainer inViewpoint="lobby" content="rx-stage-presentations" key={0 + '_cc_' + 8} /*className="catch-pointer-events"*//>
                </Container>
                : null
            }
            {
                (expertTalksIsOpen) ?
                    <div className='content-hotspot-overlay'> </div>
                : null
            }
            {/* <Container id="book-a-demo-container">
                <Button 
                    secondary
                    onClick={handleBookDemoClick}>
                Book a demo
                </Button>
            </Container> */}
        </>
    )
}

OverlayUI.propTypes = {
    hotspots: PropTypes.array,
    isMobile: PropTypes.bool,
    isSceneLoaded: PropTypes.bool
}

export default OverlayUI;